webpackJsonp([166630440199954],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.7336fb12.svg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\t\twidth: 530px;\n\t"], ["\n\t\twidth: 530px;\n\t"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t\tdisplay: block;\n\t\twidth: auto;\n\t"], ["\n\t\tdisplay: block;\n\t\twidth: auto;\n\t"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t\tpadding-top: 15rem;\n\t\tpadding-bottom: 15rem;\n\t\t", ";\n\t"], ["\n\t\tpadding-top: 15rem;\n\t\tpadding-bottom: 15rem;\n\t\t", ";\n\t"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t\t\tflex: 0 1 150px;\n\t\t"], ["\n\t\t\tflex: 0 1 150px;\n\t\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\t\t\tdisplay: none;\n\t\t"], ["\n\t\t\tdisplay: none;\n\t\t"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n\t\t\tflex: 0 1 340px;\n\t\t"], ["\n\t\t\tflex: 0 1 340px;\n\t\t"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\t\twidth: 360px;\n\t\t\tmax-width: 100%;\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t\tpadding-left: 0;\n\t\t"], ["\n\t\t\twidth: 360px;\n\t\t\tmax-width: 100%;\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t\tpadding-left: 0;\n\t\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size: 37.5px;\n\t\t\tletter-spacing: -0.6px;\n\t\t\tline-height: 42px;\n\t\t"], ["\n\t\t\tfont-size: 37.5px;\n\t\t\tletter-spacing: -0.6px;\n\t\t\tline-height: 42px;\n\t\t"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n\t\tpadding-bottom: 10rem;\n\n\t\t", " {\n\t\t\tdisplay: flex;\n\t\t}\n\t"], ["\n\t\tpadding-bottom: 10rem;\n\n\t\t", " {\n\t\t\tdisplay: flex;\n\t\t}\n\t"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n\t\tpadding: 0;\n\t\tpadding-bottom: calc(40px + env(safe-area-inset-bottom));\n\n\t\t", " {\n\t\t\ttop: calc(50% + 32px);\n\t\t\twidth: calc(100% - 80px);\n\t\t\ttransform: translate(-50%, 0);\n\t\t\tfont-size: 30px;\n\t\t\tletter-spacing: -0.48px;\n\t\t\tline-height: 30px;\n\t\t}\n\n\t\t", " {\n\t\t\tleft: calc(50% + 40px);\n\t\t}\n\t"], ["\n\t\tpadding: 0;\n\t\tpadding-bottom: calc(40px + env(safe-area-inset-bottom));\n\n\t\t", " {\n\t\t\ttop: calc(50% + 32px);\n\t\t\twidth: calc(100% - 80px);\n\t\t\ttransform: translate(-50%, 0);\n\t\t\tfont-size: 30px;\n\t\t\tletter-spacing: -0.48px;\n\t\t\tline-height: 30px;\n\t\t}\n\n\t\t", " {\n\t\t\tleft: calc(50% + 40px);\n\t\t}\n\t"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n\t\tmax-width: 60vw;\n\t\tmax-height: 60vh;\n\t"], ["\n\t\tmax-width: 60vw;\n\t\tmax-height: 60vh;\n\t"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n\t\theight: 50vh;\n\t\tmax-width: 100vw;\n\t\tobject-fit: cover;\n\t"], ["\n\t\theight: 50vh;\n\t\tmax-width: 100vw;\n\t\tobject-fit: cover;\n\t"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(27);
	
	var _polished = __webpack_require__(12);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(89);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _Transition = __webpack_require__(214);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _bodyScrollLock = __webpack_require__(87);
	
	var _components = __webpack_require__(11);
	
	var _utils = __webpack_require__(73);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(5);
	
	var _logo = __webpack_require__(216);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _utils2 = __webpack_require__(4);
	
	var _type = __webpack_require__(10);
	
	var _arrowBack = __webpack_require__(47);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseStudy = function (_Component) {
		_inherits(CaseStudy, _Component);
	
		function CaseStudy() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, CaseStudy);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				data: [],
				acf: [],
				sections: [],
				heroActive: true
			}, _this.componentWillMount = function () {
				var data = _this.props.data.wordpressCasestudy;
				var acf = JSON.parse(data.acf_json);
	
				//console.log(acf)
	
				_this.setState({
					data: data,
					acf: acf,
					sections: acf.sections
				});
	
				setTimeout(function () {
					_this.setState({
						pageLoaded: true
					});
				}, 500);
	
				if ((0, _utils2.isClient)()) {
					// onscroll event won't work here because we are locking the viewport
					(0, _bodyScrollLock.disableBodyScroll)();
					window.addEventListener('mousewheel', _this.seenHeroSplash);
					window.addEventListener('touchstart', _this.seenHeroSplash);
				}
	
				// set up timer to fade out hero splash
				_this.timer = setInterval(_this.seenHeroSplash, 5000);
			}, _this.componentDidMount = function () {
				(0, _bodyScrollLock.disableBodyScroll)();
			}, _this.componentDidUpdate = function (prevProps, prevState) {
				var heroActive = _this.state.heroActive;
	
	
				if (heroActive !== prevState.heroActive) {
					if (heroActive) {
						(0, _bodyScrollLock.disableBodyScroll)();
					} else {
						window.scrollTo(0, 0);
	
						setTimeout(function () {
							(0, _bodyScrollLock.enableBodyScroll)();
							document.body.style.overflow = 'auto';
						}, 1000);
					}
				}
			}, _this.seenHeroSplash = function () {
				if (_this.state.heroActive) {
					_this.setState({ heroActive: false });
					clearInterval(_this.timer);
				}
			}, _this.renderHeroSplash = function () {
				var _this$state = _this.state,
				    heroActive = _this$state.heroActive,
				    acf = _this$state.acf,
				    data = _this$state.data,
				    pageLoaded = _this$state.pageLoaded;
	
	
				return _react2.default.createElement(
					HeroSplash,
					{
						active: heroActive,
						onClick: function onClick() {
							return _this.seenHeroSplash();
						},
						theme: acf.opening_screen_colour_theme.colour_theme,
						animate: pageLoaded
					},
					_react2.default.createElement(
						Heading,
						null,
						data.title
					),
					_react2.default.createElement(Image, {
						alignment: acf.opening_screen_hero_position,
						src: acf.hero_image.sizes.medium2,
						animate: pageLoaded
					}),
					_this.renderMeta()
				);
			}, _this.renderSections = function () {
				var sections = _this.state.sections;
	
	
				return sections.map(function (section, i) {
					var blocks = section.blocks;
	
					if (section.display_section && section.blocks) {
						return _react2.default.createElement(_components.Section, {
							key: i,
							blocks: blocks,
							section: section,
							lastSection: i == sections.length - 1
						});
					}
				});
			}, _this.renderCredits = function () {
				var acf = _this.state.acf;
	
	
				if (acf.credits) {
					var credits = acf.credits.map(function (credit, i) {
						return _react2.default.createElement(
							Credit,
							{
								key: i
							},
							_react2.default.createElement(
								Name,
								null,
								credit.title
							),
							_react2.default.createElement(
								Val,
								null,
								credit.value
							)
						);
					});
					return _react2.default.createElement(
						Credits,
						null,
						credits
					);
				}
			}, _this.renderMeta = function () {
				var acf = _this.state.acf;
	
				return _react2.default.createElement(
					Meta,
					null,
					acf.location && _react2.default.createElement(
						Name,
						null,
						acf.location
					),
					acf.dates && _react2.default.createElement(
						Name,
						null,
						acf.dates
					),
					_this.renderCredits()
				);
			}, _this.renderContent = function () {
				var _this$state2 = _this.state,
				    data = _this$state2.data,
				    acf = _this$state2.acf;
	
	
				return _react2.default.createElement(
					_react2.default.Fragment,
					null,
					_react2.default.createElement(
						Opening,
						null,
						_react2.default.createElement(
							Left,
							null,
							_this.renderMeta()
						),
						_react2.default.createElement(
							Right,
							null,
							acf.short_description && _react2.default.createElement(Description, {
								dangerouslySetInnerHTML: { __html: acf.short_description }
							})
						)
					),
					_this.renderSections(),
					_react2.default.createElement(_components.Footer, {
						title: data.title,
						pageURL: (0, _utils2.isClient)() ? window.location.href : '',
						backLink: '/',
						backLinkText: 'Back to Home'
					})
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		CaseStudy.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener('mousewheel', this.seenHeroSplash);
			clearInterval(this.timer);
		};
	
		CaseStudy.prototype.render = function render() {
			var _state = this.state,
			    data = _state.data,
			    acf = _state.acf,
			    heroActive = _state.heroActive;
	
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(_components.ScrollProgress, null),
				this.renderHeroSplash(),
				_react2.default.createElement(
					_gatsbyPluginPageTransitions2.default,
					_utils.pageTransitionProps,
					data && _react2.default.createElement(_components.MetaTags, {
						title: "Paul Conrad Architects \u2014 Case Study : " + data.title,
						description: data.meta_description ? data.meta_description : ''
					}),
					_react2.default.createElement(
						Wrapper,
						{
							active: !heroActive
						},
						this.renderContent()
					)
				)
			);
		};
	
		return CaseStudy;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Wrapper",
		componentId: "sc-832r2p-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;overflow-x:hidden;transition:all 0.75s ease;transition-delay:0.4s;will-change:transform;transform:translateY(100px);opacity:0;", ""], function (props) {
		if (props.active) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	var Container = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Container",
		componentId: "sc-832r2p-1"
	})(["", " display:flex;flex-direction:column;"], _global.container);
	
	// Shared
	
	var Heading = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Heading",
		componentId: "sc-832r2p-2"
	})(["", ""], _global.heading);
	var Title = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Title",
		componentId: "sc-832r2p-3"
	})([""]);
	
	// Hero
	
	
	var HeroImage = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__HeroImage",
		componentId: "sc-832r2p-4"
	})([""]);
	var ProjectTitle = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__ProjectTitle",
		componentId: "sc-832r2p-5"
	})([""]);
	var Hero = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Hero",
		componentId: "sc-832r2p-6"
	})(["position:fixed;top:0;left:0;right:0;bottom:0;background:", ";", "{justify-content:center;align-items:center;}opacity:0;pointer-events:none;transition:opacity 0.5s ease-out;", ""], _themes.warmBrown.background, Container, function (props) {
		if (props.active) return (0, _styledComponents.css)(["opacity:1;pointer-events:all;"]);
	});
	
	// Opening
	
	var Left = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Left",
		componentId: "sc-832r2p-7"
	})([""]);
	var Right = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Right",
		componentId: "sc-832r2p-8"
	})([""]);
	var Opening = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Opening",
		componentId: "sc-832r2p-9"
	})(["display:flex;flex-direction:row;width:680px;max-width:100%;padding-top:25rem;padding-bottom:25rem;", " ", " ", " ", "{flex:0 1 200px;padding-right:20px;", " ", "}", "{flex:0 1 440px;padding-left:20px;", " ", "}"], _utils2.media.laptop(_templateObject), _utils2.media.tablet(_templateObject2), _utils2.media.phone(_templateObject3, _global.padding), Left, _utils2.media.laptop(_templateObject4), _utils2.media.tablet(_templateObject5), Right, _utils2.media.laptop(_templateObject6), _utils2.media.tablet(_templateObject7));
	
	var Name = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Name",
		componentId: "sc-832r2p-10"
	})([""]);
	var Credit = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Credit",
		componentId: "sc-832r2p-11"
	})([""]);
	var Val = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Val",
		componentId: "sc-832r2p-12"
	})([""]);
	var Credits = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Credits",
		componentId: "sc-832r2p-13"
	})([""]);
	
	var Meta = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Meta",
		componentId: "sc-832r2p-14"
	})(["*{", ";text-indent:0!important;}> ", " > ", "{margin-top:1rem;> ", "{font-weight:400;}}"], _type.caption, Credits, Credit, Name);
	
	var Description = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__Description",
		componentId: "sc-832r2p-15"
	})(["&,> *{", ";}"], _type.projectIntro);
	
	// Hero
	
	var fadeUp = (0, _styledComponents.css)(["transform:translateY(30px);will-change:transform;transition:all 1s ease;opacity:0;", ""], function (props) {
		if (props.animate) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	var HeroSplash = _styledComponents2.default.div.withConfig({
		displayName: "CaseStudy__HeroSplash",
		componentId: "sc-832r2p-16"
	})(["position:fixed;top:0;left:0;right:0;bottom:0;background:", ";z-index:11;padding:5rem;display:flex;flex-direction:column;", "{display:none;flex-direction:column;font-family:'Scto';font-size:10.5px;color:#FFFFFF;line-height:12px;position:absolute;bottom:10rem;left:50%;transform:translateX(-50%);}", "{font-family:'Scto';font-size:50px;color:#3A4A59;letter-spacing:-0.8px;text-align:center;line-height:50px;position:absolute;top:50%;left:50%;z-index:2;", " transform:translate(-50%,calc(-50% + 30px));", " ", "}opacity:0;pointer-events:none;transition:opacity 0.5s ease-out;", " ", " ", " ", ""], _themes.warmBrown.background, Meta, Heading, fadeUp, function (props) {
		if (props.animate) return (0, _styledComponents.css)(["transform:translate(-50%,-50%);opacity:1;"]);
	}, _utils2.media.laptop(_templateObject8), function (props) {
		if (props.active) return (0, _styledComponents.css)(["opacity:1;pointer-events:all;"]);
	}, function (props) {
		if (props.theme) {
			var theme = _themes.themes[props.theme];
			return (0, _styledComponents.css)(["background:", ";", "{color:", "}", "{color:", "}"], theme.background, Heading, theme.text, Name, theme.text);
		}
	}, _utils2.media.tablet(_templateObject9, Meta), _utils2.media.phone(_templateObject10, Heading, Meta));
	
	var Image = _styledComponents2.default.img.withConfig({
		displayName: "CaseStudy__Image",
		componentId: "sc-832r2p-17"
	})(["width:100%;height:100%;max-width:70vw;max-height:70vh;object-fit:contain;object-position:left;", " ", " ", " transition-delay:0.6s;", ""], _utils2.media.laptop(_templateObject11), function (props) {
		if (props.alignment == 'right') return (0, _styledComponents.css)(["align-self:flex-end;object-position:right;"]);
	}, fadeUp, _utils2.media.phone(_templateObject12));
	
	exports.default = CaseStudy;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.encode = encode;
	exports.getParameterByName = getParameterByName;
	exports.getUrlDomain = getUrlDomain;
	exports.rgb = rgb;
	function encode(data) {
	    return Object.keys(data).map(function (key) {
	        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	    }).join("&");
	}
	
	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	function getUrlDomain() {
	    if (!window.location.origin) {
	        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    }
	    return window.location.origin;
	}
	
	function rgb(hex) {
	    "use strict";
	
	    if (hex.charAt(0) === '#') {
	        hex = hex.substr(1);
	    }
	    if (hex.length < 2 || hex.length > 6) {
	        return false;
	    }
	    var values = hex.split(''),
	        r,
	        g,
	        b;
	
	    if (hex.length === 2) {
	        r = parseInt(values[0].toString() + values[1].toString(), 16);
	        g = r;
	        b = r;
	    } else if (hex.length === 3) {
	        r = parseInt(values[0].toString() + values[0].toString(), 16);
	        g = parseInt(values[1].toString() + values[1].toString(), 16);
	        b = parseInt(values[2].toString() + values[2].toString(), 16);
	    } else if (hex.length === 6) {
	        r = parseInt(values[0].toString() + values[1].toString(), 16);
	        g = parseInt(values[2].toString() + values[3].toString(), 16);
	        b = parseInt(values[4].toString() + values[5].toString(), 16);
	    } else {
	        return false;
	    }
	    return "rgb(" + r + ", " + g + ", " + b + ")";
	}
	
	var pageTransitionProps = exports.pageTransitionProps = {
	    defaultStyle: {
	        width: '100vw',
	        maxWidth: '100%',
	        transition: 'opacity 500ms ease-out',
	        opacity: 0
	    },
	    transitionStyles: {
	        entering: { opacity: '0' },
	        entered: { opacity: '1' },
	        exiting: { opacity: '0' }
	    }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-study-js-48674770ad84138e9507.js